var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_Set.js
// module id = 823
// module chunks = 0 1 2 3 4 5 6 7 8